<template>
  <div
    @click.stop="handleClick()"
    class="relative flex cursor-pointer flex-row items-center rounded p-1 text-sm outline-none focus-within:ring-1 focus-within:ring-tertiary focus-within:ring-offset-0"
    :id="id"
  >
    <Icon
      :class="{
        'text-gray-400': disabled,
      }"
      >{{
        !!modelValue ? $icons.CHECKBOX_CHECKED : $icons.CHECKBOX_NOT_CHECKED
      }}</Icon
    >
    <input
      ref="inputRef"
      type="checkbox"
      :checked="!!modelValue"
      :id="`${id}-input`"
      class="sr-only"
      :disabled="disabled"
      :aria-label="ariaLabel || undefined"
      @keydown.space.prevent="handleClick"
      @keydown="$emit('keydown', $event)"
    />
    <span v-if="$slots.default" :class="{ 'text-gray-400': disabled }">
      <slot />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'Checkbox',
  emits: ['update:modelValue', 'keydown'],
  props: {
    modelValue: {
      type: [Boolean, Number],
      default: false,
    },
    id: {
      type: String,
      default: 'switch',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    /** Visually hidden; use when there is no slot label (icon-only checkbox). */
    ariaLabel: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    const inputRef = ref<HTMLInputElement | null>(null)
    const handleClick = () => {
      if (props.disabled) return
      inputRef.value?.focus()
      context.emit('update:modelValue', !props.modelValue)
    }

    return { inputRef, handleClick }
  },
})
</script>
